module.exports = __webpack_public_path__ + "img/features.f54fdc8d.webp";